import { AUTH_API, handleApiError } from '../../utils/axios';

export const getVehicles = async (search) => {
  try {
    const { data } = await AUTH_API.get(
      `/api/v1/vehicles?page=${search.page}&size=${search.size}&search=${search.search}`,
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
